module.exports = __webpack_public_path__ + "img/bz.5f410821.svg";